import { FilterStatus } from "@/components/StatusTableTab";
import {
  persistBoPreference,
  readBoPreference,
  removeBoPreference,
} from "@/lib/user-preferences/store";
import { createContext, Dispatch, SetStateAction, useContext } from "react";

export type FilterStatusContextType = {
  filterStatus: FilterStatus;
  setFilterStatus: Dispatch<SetStateAction<FilterStatus>>;

  setWhereQuery: object;

  setId: string | undefined;
  setSetId: Dispatch<SetStateAction<string | undefined>>;
  computeFilterStatusQueryContent: <T>(statusField: keyof T) => object;
};

export const AdditionalFiltersContext = createContext<
  FilterStatusContextType | undefined
>(undefined);

export function useAdditionalFilters() {
  const context = useContext(AdditionalFiltersContext);
  return context;
}

/**
 * To access the setId from outside the context
 */
export function useSetExternal() {
  const setIdKey = (resourceType: string) => `${resourceType}.setId`;

  const getSetId = (resourceType: string) => {
    const parsed = readBoPreference<string>(setIdKey(resourceType));
    if (parsed !== undefined) return parsed;
    const legacy = localStorage.getItem(setIdKey(resourceType));
    if (legacy == undefined) return undefined;
    return JSON.parse(legacy) as string;
  };

  const deleteSetId = (resourceType: string) => {
    removeBoPreference(setIdKey(resourceType));
  };

  const setSetId = (resourceType: string, value: string) => {
    persistBoPreference(setIdKey(resourceType), value);
  };

  return { getSetId, deleteSetId, setSetId };
}
